import { Download, Smartphone } from 'lucide-react'
import React from 'react'

const Hero = () => {
    const scrollToSection = (sectionId: string) => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <section id="hero" className="pt-16 bg-gradient-to-br from-[#002047] to-blue-800 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="space-y-8">
                        <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
                            Revolutionize Your
                            <span className="text-blue-300"> Dairy Business</span>
                        </h1>
                        <p className="text-xl text-blue-100 leading-relaxed">
                            Smart Dairy is the ultimate CRM and management solution for large milk production companies. Streamline operations, track inventory, manage customers, and boost your business efficiency.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={() => scrollToSection('download')}
                                className="bg-white text-[#002047] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 transition-all transform hover:scale-105 flex items-center justify-center space-x-2"
                            >
                                <Download className="h-5 w-5" />
                                <span>Download App</span>
                            </button>
                            <button
                                onClick={() => scrollToSection('about')}
                                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-[#002047] transition-all"
                            >
                                Learn More
                            </button>
                        </div>
                    </div>
                    <div className="relative">
                        <div className=" rounded-2xl p-8 transform rotate-3 hover:rotate-0 transition-transform duration-300">
                            <img src='./logo.png' className="h-64 w-64 mx-auto text-white" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero
